import './globalStyles.scss'
import './header.scss'
import './loginPage.scss'
import './sidebar.scss'
import './batchScreen.scss'
import './realTimeScreen.scss'
import './fullReport.scss'
import './companyReport.scss'
import './ownershipStructure.scss'
import './table.scss'
